export default __webpack_public_path__ + "static/media/refresh_animate.37b32170.gif";